import { str2svg } from "./utils";
export { str2svg, type IconStyle, type IconName } from "./utils";

const BASE_URL = import.meta.env.BASE_URL.endsWith("/") ? import.meta.env.BASE_URL : `${import.meta.env.BASE_URL}/`;

export default async function getIcon({style, name}:{style: string, name: string}){
  // console.log(`${import.meta.env.SITE_URL}/_icon/${style}/${name}.svg`);
  const res = await fetch(`${BASE_URL}icon/${style}/${name}.svg`)
    .then(response => response.text())
    .catch(reason => {
      console.error(reason);
      return undefined;
    });
  return str2svg(res ?? "");
}